import React, { act, useEffect, useState } from 'react';
import "../style/dashboard.css";
import "../style/common.css";
import api from "../utils/api";
import { ButtonComponent, FilterButtonComponent } from "../component/Common";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Select from 'react-select';

const StaffDashboard = () => {
    const navigate = useNavigate();
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [formList, setFormList] = useState([]);
    const [userType, setUserType] = useState(null);
    const [isNoData, setIsNoData] = useState(true);
    const [staffList, setStaffList] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState({});
    const [activeButton, setActiveButton] = useState("All");

    const handleClick = (name) => {
        setActiveButton(name);
        fetchDashboardData(name)
    };

    useEffect(() => {
        setIsInitialLoad(false);
    }, []);

    useEffect(() => {
        if (!isInitialLoad) {
            fetchDashboardData(activeButton);
        }
    }, [isInitialLoad]);

    const fetchDashboardData = async (status) => {
        try {
            const result = await api.get(`/get-staff-dashboard?status=${status}`);
            if (result.status === 200 && Array.isArray(result.data.data)) {
                const data = result.data.data;
                setFormList(data);
                setUserType(result.data.userType);
                setIsNoData(data.length === 0);
            } else {
                setFormList([]);
                setIsNoData(true);
            }
        } catch (error) {
            setFormList([]);
            setIsNoData(true);
        }
    };

    const manageStaff = () => {
        navigate('/mga-staff-portal/manage-staff');
    };

    const fetchStaffList = async () => {
        try {
            const result = await api.get('/get-staff-list');
            if (result.status === 200 && Array.isArray(result.data)) {
                const formattedStaffList = result.data.map(staff => ({
                    value: staff.id,
                    label: `${staff.name} (${staff.phone})`
                }));
                setStaffList(formattedStaffList);
            }
        } catch (error) {
            console.log("error", error)
        }
    };

    useEffect(() => {
        fetchStaffList();
    }, []);

    const handleAssignTask = async (formId, staffId) => {
        try {
            const result = await api.post(`/assign-task`, { formId, staffId });
            if (result.status == 200) {
                Swal.fire({
                    icon: "success",
                    title: result.data.message,
                    iconColor: '#008000',
                    showConfirmButton: false,
                    timer: 2000
                });
                fetchDashboardData(activeButton);
            } else {
                console.log("error", result.data)
            }
        } catch (error) {
            console.log("error", error)
        }
    };

    const handleSelectChange = (formId, staffId) => {
        setSelectedStaff((prev) => ({ ...prev, [formId]: staffId }));
        handleAssignTask(formId, staffId);

    };

    const viewApplication = (id) => {
        navigate(`/mga-staff-portal/form-details-view?id=${id}`);
    };

    return (
        <>
            <div className="dashboard-container">
                <div className="table-container">
                    <div className="parent-div">
                        <div className="child1">
                            <h2>Welcome</h2>
                            {userType != null && userType === 'admin' ? (
                                <h2>Admin</h2>
                            ) : (
                                <h2>{formList[0]?.phone}</h2>
                            )}
                        </div>
                        {userType === 'admin' && (
                            <div className="child2">
                                <ButtonComponent
                                    tooltipId={"my-tooltip-2"}
                                    name="Manage Staff"
                                    onClick={manageStaff}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className="filter_btn_div">
                    {["All", "In Progress", "Rejected", "Accepted"].map((buttonName) => (
                        <FilterButtonComponent
                            key={buttonName}
                            name={buttonName}
                            isActive={activeButton === buttonName}
                            onClick={() => handleClick(buttonName)}
                        />
                    ))}
                </div>
                {isNoData ? (
                    userType === 'admin' ? (
                        <div className="no-data-message">
                            <p>No Application Found.</p>
                        </div>
                    ) : (
                        <div className="no-data-message">
                            <p>No task found. Please contact your administration.</p>
                        </div>
                    )
                ) : (
                    <div className="table-container">
                        {formList.map((form, index) => (
                            <div className="row-container" key={index}>
                                <div className="row">
                                    <div className="heading-column">Application ID</div>
                                    <div className="data-column">{form.formsDetails.applicationId}</div>
                                </div>
                                <div className="row">
                                    <div className="heading-column">Loan Amount</div>
                                    <div className="data-column">{form.formsDetails.loanAmount}</div>
                                </div>
                                <div className="row">
                                    <div className="heading-column">Loan Type</div>
                                    <div className="data-column">{form.formsDetails.loanType}</div>
                                </div>
                                <div className="row">
                                    <div className="heading-column">Application Status</div>
                                    <div className="data-column">{form.formsDetails.applicationStatus}</div>
                                </div>
                                {form.formsDetails.feedback !== null && (
                                    <div className="row">
                                        <div className="heading-column">Feedback</div>
                                        <div className="data-column">{form.formsDetails.feedback}</div>
                                    </div>
                                )}
                                <div className="row">
                                    <div className="heading-column">{userType == "admin" ? "Assign Task To" : "Review Application"}</div>
                                    <div className="data-column">
                                        <div className="action-button">
                                            {userType === "admin" && form.formsDetails.applicationStatus !== 'Rejected' && (
                                                <>
                                                    <Select
                                                        className="staff-list"
                                                        options={staffList}
                                                        value={staffList.find(
                                                            (option) => option.label === `${form.formsDetails.assignTo} (${form.formsDetails.staffContact})`
                                                        )}
                                                        onChange={(selectedOption) =>
                                                            handleSelectChange(form.formsDetails.form_id, selectedOption.value)
                                                        }
                                                        placeholder="Assign Task To"
                                                        isSearchable
                                                        styles={{
                                                            container: (provided) => ({
                                                                ...provided,
                                                                width: "40%",
                                                                margin: "0",
                                                            }),
                                                        }}
                                                    />

                                                </>
                                            )}
                                            <ButtonComponent
                                                name="View Application"
                                                onClick={() => viewApplication(form.formsDetails.form_id)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <ReactTooltip
                id="my-tooltip-2"
                place="bottom"
                variant="info"
                content="Create staff member"
            />
        </>
    );
};

export default StaffDashboard;